<template>
  <div class="t7_housedetail" v-if="pageInfo&&houseDeatailInfo">
    <div
      class="image-layer"
      v-viewer
    >
		<img :src="houseDeatailInfo.main_img" :key="houseDeatailInfo.main_img" :alt="houseDeatailInfo.name" />
    </div>

    <div class="title-layer">
    	<div class="title">{{pageInfo.Extinfo.buildingName}}</div>
    	<div class="fangdai" @click="clickGoFd()">房贷计算器</div>
    </div>

    <div class="price-layer" v-if="houseDeatailInfo.housetype_price">
    	<div class="price">{{houseDeatailInfo.housetype_price}}</div>
    	<div class="txt">参考均价</div>
    </div>

    <div class="tag-layer"><span>{{houseDeatailInfo.name}}</span></div>

    <div class="detail-layer">
    	<div class="item-layer">
          <div class="txt">
            <span>建筑面积：</span>
            {{houseDeatailInfo.housetype_buildarea ? houseDeatailInfo.housetype_buildarea : '待公布'}}
          </div>    		
    	</div>
    	<div class="item-layer">
          <div class="txt">
            <span>套内面积：</span>
            {{houseDeatailInfo.housetype_truearea ? houseDeatailInfo.housetype_truearea : '待公布'}}
          </div>    		
    	</div>
    	<div class="item-layer">
          <div class="txt">
            <span>最新开盘：</span>
            {{houseDeatailInfo.housetype_bookdate ? houseDeatailInfo.housetype_bookdate : '待公布'}}
          </div>    		
    	</div>
    	<div class="item-layer">
          <div class="txt">
            <span>最早交房：</span>
            {{houseDeatailInfo.housetype_takedate ? houseDeatailInfo.housetype_takedate : '待公布'}}
          </div>    		
    	</div>
    	<div class="item-layer">
          <div class="txt">
            <span>所属楼盘：</span>
            {{pageInfo.Extinfo.buildingName}}
          </div>    		
    	</div>
    	<div class="item-layer">
          <div class="txt">
            <span>户型结构：</span>
            {{houseDeatailInfo.name}}
          </div>    		
    	</div>
    </div>

    <div class="myline" v-if="list.length > 0"></div>
    <div class="comment-layer" v-if="list.length > 0">
    	<div class="title">户型点评</div>
    	<div class="item" v-for="(item,index) in list" :key="index">{{item}}</div>
    </div>
    <Tabbar10></Tabbar10>
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
import Vue from "vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
const Tabbar10 = () => import("@/components/tabbar10");
Vue.use(Viewer);
Viewer.setDefaults({
  title: function(item) {
    if (item.alt.startsWith("####")) {
      return item.alt.replace("####", "");
    }
    return "";
  },
  toolbar: {
    zoomIn: false,
    zoomOut: false,
    oneToOne: false,
    reset: false,
    prev: false,
    play: false,
    next: false,
    rotateLeft: false,
    rotateRight: false,
    flipHorizontal: false,
    flipVertical: false
  }
});


export default {
  components: {
    BtnBackLayout4,
    Tabbar10
  },
  props: {},
  data() {
    return {
    	list: [],
	  	houseDeatailInfo: null,
	  	idx: parseInt(this.$route.query.index)    	
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
      "rsCardInfo"
    ])
  },
  methods: {
    // lj28
    clickGoFd() {
      let link = `${location.protocol}//${location.host}/activities/housing-loan/index.html`;
      util.openOtherLink(link);
    },

  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo"]).then(() => {
      if (
        this.pageInfo.Extinfo &&
        this.pageInfo.Extinfo.floorPlan &&
        this.pageInfo.Extinfo.floorPlan.length > 0
      ) {
        this.houseDeatailInfo = this.pageInfo.Extinfo.floorPlan[this.idx]
    	if(this.houseDeatailInfo.housetype_comments) {
    		this.list = this.houseDeatailInfo.housetype_comments.split('|$$|')
    	}
    	console.log(this.houseDeatailInfo)
      }
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.t7_housedetail {
	margin: 0.2rem .3rem;
	padding-bottom: 60px;
}
.image-layer > img {
	display: block;
	width: 100%;
}
.title-layer {
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: .7rem;
	margin-top: .2rem;
}
.title-layer .title {
	flex: 1;
    font-weight: 600;
    color: #3a3a3a;
    font-size: 18px;	
}
.fangdai {
  color: #0086ee;
  font-size: 0.24rem;
  background: url("https://assets.rurushishi.com/yq-rs-make/huafa/jisuanqi.png")
    no-repeat left center;
  background-size: 0.26rem 0.26rem;
  padding-left: 0.36rem;
}
.price-layer {
	display: flex;
/*	align-items: center;
	justify-content: center;*/
	line-height: .6rem;	
}
.price-layer .price {
	color: #d0151b;
    font-size: 0.32rem;
    padding-right: 10px;
    display: block;
}
.price-layer .txt {
    font-size: 0.24rem;
    color: #7b7b7b;
}
.tag-layer {
	margin-top: .2rem;
}
.tag-layer > span {
	background-color: rgba(252, 234, 227, 1);
	padding: 6px 12px;
	font-size: 0.22rem;
	color: #ff6600;
	border-radius: 4px;
}
.detail-layer {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 0px;
}
.detail-layer .item-layer {
  width: 50%;
}
.detail-layer .item-layer.flex {
  width: 100%;
}
.detail-layer .item-layer .txt {
  color: #2f2c2f;
  font-size: 0.26rem;
  line-height: 0.6rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;  
}
.detail-layer .item-layer .txt > span {
  color: #999999;
}
.myline {
  height: 5px;
  width: 100%;
  background-color: #ededed;
}
.comment-layer {
	margin-top: .2rem;
}
.comment-layer .title {
	line-height: .6rem;
    font-weight: 600;
    color: #3a3a3a;
    font-size: 16px;
}
.comment-layer .item {
	line-height: .5rem;
	color: #666666;
	font-size: .24rem;
	position: relative;
	padding-left: 20px;
}
.comment-layer .item:before {
	position: absolute;
	content: '';
	width: 6px;
	height: 6px;
	left: 8px;
	background-color: #999999;
	top: 8px;
	transform:rotate(45deg);
}
</style>